/**
 * Нормализует почту клиента для UI: lte-centr.ru → lte-center.ru, @kraken.local → @lte-center.ru.
 */
export const normalizeClientCabinetEmailDisplay = (raw) => {
  if (raw == null || raw === '') {
    return '';
  }
  return String(raw)
    .replace(/lte-centr\.ru/gi, 'lte-center.ru')
    .replace(/@kraken\.local$/i, '@lte-center.ru');
};
